import axios from "axios";
import { format } from "date-fns";
import GA4React from "ga-4-react";
export const API_URL = "/";
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

export const ga4react = new GA4React("G-DRLJ9VETJK");

api.interceptors.response.use(
  (response) => {
    if (response?.data?.Errors?.length > 0 || response?.data?.HasErrors) {
    } else {
    }
    return response;
  },
  async function (error) {
    if (error?.response?.status === 500) {
      //window.location.replace("/?error=500");
    }
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      localStorage.setItem("loggedin", JSON.stringify(false));
      if (window.location.pathname !== "/login") {
        window.location.replace("/logout");
      }
    }
    return Promise.reject(error);
  }
);

export function ObjectRemoveEmptyProperty(obj: any) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      obj[propName] = "";
    }
  }
  return obj;
}

export function tryFormat(
  input: Date | null | undefined,
  formatString: string,
  nullValue?: any
) {
  if (!input || input === undefined) {
    return nullValue;
  } else if (!input.getMonth) {
    input = new Date(input);
  }
  return format(input, formatString);
}

export const WEEKDAYS_SHORT = {
  nl: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
};

export const MONTHS = {
  nl: [
    "Januari",
    "Februari",
    "Maart",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "December",
  ],
};

export const WEEKDAYS_LONG = {
  nl: [
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrijdag",
    "Zaterdag",
    "Zondag",
  ],
};

export const FIRST_DAY_OF_WEEK = {
  nl: 1,
};
// Translate aria-labels
export const LABELS = {
  nl: { nextMonth: "Vorige maand", previousMonth: "Volgende maand" },
};

export interface IItem {
  id: string;
  timefrom: Date;
  available?: number;
  description?: string;
  customername?: string;
  existing: boolean;
  done: boolean;
  reservationid?: string;
  timetitle?: string;
  fraction?: string;
  // The confirmation mail did not arrive (bounced, dropped or not sent).
  mailfailed?: boolean;
  mailreason?: string;
}

export interface IItems extends Array<IItem> {}
